module.exports = __webpack_public_path__ + "img/thumbnails-9-expense-tracker.ba43c1fb.png";